export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "dismiss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["J'ai compris"])}
      },
      "en": {
        "dismiss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Got it"])}
      }
    }
  })
}
